var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8.86523C0.5 4.7231 3.85786 1.36523 8 1.36523H32C36.1421 1.36523 39.5 4.7231 39.5 8.86523V32.8652C39.5 37.0074 36.1421 40.3652 32 40.3652H8C3.85786 40.3652 0.5 37.0074 0.5 32.8652V8.86523Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8.86523C0.5 4.7231 3.85786 1.36523 8 1.36523H32C36.1421 1.36523 39.5 4.7231 39.5 8.86523V32.8652C39.5 37.0074 36.1421 40.3652 32 40.3652H8C3.85786 40.3652 0.5 37.0074 0.5 32.8652V8.86523Z",
    stroke: "#E4E7EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7493 29.1979V25.0313M13.7493 16.6979V12.5312M11.666 14.6146H15.8327M11.666 27.1146H15.8327M20.8327 13.3646L19.3875 17.122C19.1525 17.733 19.035 18.0385 18.8523 18.2955C18.6903 18.5232 18.4913 18.7222 18.2636 18.8842C18.0066 19.0669 17.7011 19.1844 17.0901 19.4194L13.3327 20.8646L17.0901 22.3097C17.7011 22.5447 18.0066 22.6622 18.2636 22.845C18.4913 23.0069 18.6903 23.2059 18.8523 23.4337C19.035 23.6907 19.1525 23.9962 19.3875 24.6072L20.8327 28.3646L22.2778 24.6072C22.5128 23.9962 22.6303 23.6907 22.8131 23.4337C22.975 23.2059 23.174 23.0069 23.4018 22.845C23.6588 22.6622 23.9643 22.5447 24.5753 22.3097L28.3327 20.8646L24.5753 19.4194C23.9643 19.1844 23.6588 19.0669 23.4018 18.8842C23.174 18.7222 22.975 18.5232 22.8131 18.2955C22.6303 18.0385 22.5128 17.733 22.2778 17.122L20.8327 13.3646Z",
    stroke: "#23772F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.da321a43fb2f0ba2e3884c7e89bc6a09.svg";
export { ForwardRef as ReactComponent };